import React from 'react'
import { LightBulbIcon } from 'images'
import LoaderSpinner from 'components/Shared/Loader/LoaderSpinner'
import { useTranslation } from 'react-i18next'

const GenerateButton = ({ onClick, disabled = false, loading = false }) => {
  const { t } = useTranslation()

  return (
    <button type="button" className={`generate-button ${loading ? 'generating' : ''} ${disabled ? 'disabled' : ''}`} onClick={onClick} disabled={disabled} loading={loading}>
      <span className="icon">
        {loading ? 
          <LoaderSpinner
            className="bt-loading-spinner"
            showText={false}
            size="mini"
            portalBackground={false}
          />
          : 
          <LightBulbIcon width={16} height={16} />}
      </span>

      <span className="text">{loading ? t('Recommendations.campaign.setup.coCreatePanel.generating') : t('Recommendations.campaign.setup.coCreatePanel.generate')}</span>
    </button>
  )
}

export default GenerateButton